import { Injectable } from '@angular/core';
import { AppService } from '../shared/service/AppService.class';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class AgentService extends AppService<any>{
  constructor(protected http: HttpClient) {
    super(http);
    this.appmod = "agentsGroup";
  }
  getGraph2(): Observable<any>{
    this.appmod='custom/agentGraph2'
    let result = super.getService();
    this.appmod = "agentsGroup";
    return result;
  }

  checkvaliddata(id: any): Observable<any> {
    let tmp = this.appmod
    this.appmod = "checkagentvalidgroup";
    let result = super.getService(id);
    this.appmod = tmp
    return result;
  }

  public checkvalidlist(id,type): Observable<any> {
    let tmp=this.appmod
    this.appmod = "checkallliststatus";
    let result = super.getService(id,type);
    this.appmod=tmp
    return result;
  }


  updateCalendarGroupid(data: any): Observable<any> {
    let tmp = this.appmod
    this.appmod = "custom/updateCalendarGroupid";
    let result = super.saveService(data);
    this.appmod = tmp
    return result;
  }

  updateemailGroup(data: any): Observable<any> {
    let tmp = this.appmod
    this.appmod = "custom/updateemailGroup";
    let result = super.saveService(data);
    this.appmod = tmp
    return result;
  }

  public getAgentGroupEmail(data: any): Observable<any> {
    let tmp = this.appmod
    this.appmod = "custom/getAgentGroupEmail";
    let result = super.saveService(data);
    this.appmod = tmp
    return result;
  }

  public getAgentGroupCalendar(data: any): Observable<any> {
    let tmp = this.appmod
    this.appmod = "custom/getAgentGroupCalendar";
    let result = super.saveService(data);
    this.appmod = tmp
    return result;
  }

  

  public getGroupEmail(data: any): Observable<any> {
    let tmp = this.appmod
    this.appmod = "custom/getGroupEmail";
    let result = super.saveService(data);
    this.appmod = tmp
    return result;
  }

  public getEmail(filter: any): Observable<any> {
    let tmp = this.appmod
    this.appmod = "custom/getemail";
    let result = super.getService(filter);
    this.appmod = tmp
    return result;
  }

  public getCaledar(filter: any): Observable<any> {
    let tmp = this.appmod
    this.appmod = "custom/getcalendar";
    let result = super.getService(filter);
    this.appmod = tmp
    return result;
  }

  public saveAgentGroups(data): Observable<any> {
    let temp = this.appmod;
    this.appmod = "custom/saveAgentGroups";
    let result = super.saveService(data);
    this.appmod = temp;
    return result;
  }

  public saveGroup(data): Observable<any> {
    this.appmod = "custom/saveAgentGroups";
    let result = super.saveService(data);
    this.appmod = "agentsGroup";
    return result;
  }
  public getAgentGroup(): Observable<any> {
    this.appmod = "custom/getAgentGroup";
    let result = super.getService();
    this.appmod = "agentsGroup";
    return result;
  }
  getAgentgroups(data?:any): Observable<any>{
    this.appmod='custom/agentGroup'
    let result = super.getService(data);
    this.appmod = "agentsGroup";
    return result;
  }

  getHeaders(data?:any): Observable<any>{
    this.appmod='custom/getHeaders'
    let result = super.getService(data);
    this.appmod = "agentsGroup";
    return result;
  }

  saveAgent(data?:any): Observable<any>{
    let temp = this.appmod;
    this.appmod='custom/saveAgent'
    let result = super.saveService(data);
    this.appmod = temp;
    return result;
  }
  saveMultiAgent(data){
    this.appmod='custom/saveMultiAgent'
    let result = super.saveService(data);
    this.appmod = "agentsGroup";
    return result;
  }

  public getagents(filter:any): Observable<any> {
    this.appmod = "custom/getagents";
    let result = super.getService(filter);
    this.appmod = "agentsGroup";
    return result;
  }

  public mapAgent(data:any): Observable<any> {
    this.appmod = "custom/mapAgent";
    let result = super.saveService(data);
    this.appmod = "agentsGroup";
    return result;
  }

  public deleteAgent(key): Observable<any> {
    this.appmod = "custom/deleteagent";
    let result = super.deleteService(key);
    this.appmod = "agentsGroup";
    return result;
  }

  public deleteAgentGroup(key:any,type:any): Observable<any> {
    this.appmod = "custom/deleteAgentGroup";
    let result = super.deleteService(key,type);
    this.appmod = "agentsGroup";
    return result;
  }

  public getAgentReports(id:any): Observable<any> {
    this.appmod = "custom/getAgentReports";
    let result = super.getService(id);
    this.appmod = "agentsGroup";
    return result;
  }

  public getTopbox(id:any): Observable<any> {
    this.appmod = "custom/getagentTopbox";
    let result = super.getService(id);
    this.appmod = "agentsGroup";
    return result;
  }
  public getdidgroups(id:any): Observable<any> {
    this.appmod = "custom/didgroups";
    let result = super.getService(id);
    this.appmod = "agentsGroup";
    return result;
  }

  public updateidagent(data:any): Observable<any> {
    this.appmod = "custom/setagentgroupid";
    let result = super.saveService(data);
    this.appmod = "agentsGroup";
    return result;
  }


    public getagentDIDs(data:any): Observable<any> {
    this.appmod = "didagentdata";
    let result = super.saveService(data);
    this.appmod = "agentsGroup";
    return result;
  }

  public updateAgents(data:any): Observable<any> {
    this.appmod = "custom/updateAgent";
    let result = super.saveService(data);
    this.appmod = "agentsGroup";
    return result;
  }

  public getSkills(): Observable<any> {
    let tmp = this.appmod;
    this.appmod = "skill";
    let result = super.getService();
    this.appmod = tmp;
    return result;
  }

  public getLanguages(): Observable<any> {
    let tmp = this.appmod;
    this.appmod = "language";
    let result = super.getService();
    this.appmod = tmp;
    return result;
  }

  public getMessages(): Observable<any> {
    return super.getOption("message");
  }

  public syncAgentGroupQueueAudio(data: any): Observable<any> {
    let tmp = this.appmod;
    this.appmod = "custom/syncAgentGroupQueueAudio";
    let result = super.saveService(data);
    this.appmod = tmp;
    return result;
  }

}
